import axios from "../../utils/axios";

async function fetchList(params) {
  return await axios.get(`/single/orders`, { params });
}

async function fetch(id) {
  return await axios.get(`/orders/${id}`);
}

async function create(data) {
  return await axios.post(`single/orders`, data);
}

async function updateStatus(id, data) {
  return await axios.patch(`/orders/${id}/status`, data);
}

async function fetchStats() {
  return await axios.get(`single/orders/stats`);
}

async function createBilling(data) {
  return await axios.post(`single/orders/billing`, data);
}

const orderService = {
  fetchList,
  fetch,
  updateStatus,
  fetchStats,
  create,
  createBilling,
};
export default orderService;
